<template>
  <div class="list-card-wrap v-scroll-item relative-position evecardwrap" :id="'eCardWrap'+event.eveid" :ref="'eCardWrap'+event.eveid" :style="eventHeight(event, 'ecw', isRB)">
    <div class="list-card-inner">
      <div class="c-match-card relative-position evecard" :id="'eCard'+event.eveid" :ref="'eCard'+event.eveid" :style="eventHeight(event, 'ec', isRB)">
        <div class="c-match-item match-tpl0-bg more-handicap csid-1">
          <div class="process-col yb-flex-center">
            <sportTime :event="event"></sportTime>
          </div>
          <div class="match-handicap-item-wrap match-handicap-item-wrap-simple">
            <template v-for="(subMatch, subMatchKey) in (event.sub + 1)" v-if="showSubMatch(subMatch, event, subMatchKey, true)">
              <div class="match-handicap-item" v-if="subMatchKey == 0">
                <div class="c-match-handicap c-match-handicap-simple" :id="'cmatch'+event.eveid">
                  <div class="vrow no-wrap">
                    <!-- FT R1X2 -->
                    <div class="handicap-col handicap-col-simple" :id="'handicapCol'+event.eveid+(isRB? ronex2BetType:onex2BetType)+ftPlyType+subMatchKeyCap[subMatchKey]">
                        <div class="bet-item-wrap home" style="width: 100% !important;">
                            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon" >
                                <!-- <div class="handicap-value" style="justify-content: left; margin: 0 10px; text-align: left;">
                                    <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                    <div class="handicap-value-text" :style="getWidth()">
                                        <template v-if="subMatchKey == 0">
                                            <div class="team-name home ellipsis allow-user-select" :title="getTeamCapt(event.tacapt)" v-html="getTeamCapt(event.tacapt)"></div>
                                        </template>
                                    </div>
                                </div> -->
                                <div class="ellipsis-wrap">
                                  <div class="vrow no-wrap absolute-full">
                                    <div class="team-name home ellipsis allow-user-select" :title="getTeamCapt(event.tacapt)" v-html="getTeamCapt(event.tacapt)"></div>
                                    <span class="red-ball" :style="{ display : (event.rbinfo && event.rbinfo.rca>0)? 'block':'none' }">
                                      <template v-if="(event.rbinfo && event.rbinfo.rca>0)">
                                        {{ event.rbinfo.rca }}
                                      </template>
                                    </span>
                                  </div>
                                </div>
                                <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamHome" :plyType="ftPlyType" :betType="(isRB? ronex2BetType:onex2BetType)" :mode="'simple'" />
                                <!-- <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamHome" :plyType="ftPlyType" :betType="(isRB? ronex2BetType:onex2BetType)" /> -->
                            </div>
                        </div>
                        <div class="yb-flex-center" style="width: 20%;">
                            <!-- <span class="red-ball" :style="{ display : (event.rbinfo && event.rbinfo.rca>0)? 'block':'none' }">
                              <template v-if="(event.rbinfo && event.rbinfo.rca>0)">
                                  {{ event.rbinfo.rca }}
                              </template>
                            </span> -->
                            <div class="score">
                                <template v-if="(event.rbinfo && event.rbinfo.scoa>=0)">
                                    {{ event.rbinfo.scoa }}
                                </template>
                            </div>
                        </div>
                        <template v-if="subMatchKey == 0">
                            <div class="bet-item-wrap draw" style="width: 50% !important;">
                                <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                    <div class="handicap-value" style="justify-content: left; margin: 0 10px;">
                                        <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                        <div class="handicap-value-text">
                                            <template v-if="subMatchKey == 0">
                                                <!-- <template v-if="event.od[ftPlyType] && event.od[ftPlyType][(isRB? ronex2BetType:onex2BetType)] && event.od[ftPlyType][(isRB? ronex2BetType:onex2BetType)]['oddsd']"> -->
                                                    {{ lang.sportAllBet['ALL_BET.LBL_DRAW'] }}
                                                <!-- </template> -->
                                            </template>
                                        </div>
                                    </div>
                                    <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamDraw" :plyType="ftPlyType" :betType="(isRB? ronex2BetType:onex2BetType)" :mode="'simple'" />
                                    <!-- <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamDraw" :plyType="ftPlyType" :betType="(isRB? ronex2BetType:onex2BetType)" /> -->
                                </div>
                            </div>
                        </template>
                        <div class="yb-flex-center" style="width: 20%;">
                            <!-- <span class="red-ball" :style="{ display : (event.rbinfo && event.rbinfo.rcb>0) ? 'block':'none' }">
                              <template v-if="(event.rbinfo && event.rbinfo.rcb>0)">
                                  {{ event.rbinfo.rcb }}
                              </template>
                            </span> -->
                            <div class="score">
                                <template v-if="(event.rbinfo && event.rbinfo.scob>=0)">
                                    {{ event.rbinfo.scob }}
                                </template>
                            </div>
                        </div>
                        <div class="bet-item-wrap away" style="width: 100% !important;">
                            <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                <!-- <div class="handicap-value" style="justify-content: left; margin: 0 10px; text-align: left;">
                                    <span class="handicap-more" style="display: none; width: min-content;">&nbsp;</span>
                                    <div class="handicap-value-text" :style="getWidth()">
                                        <template v-if="subMatchKey == 0">
                                            <div class="team-name away ellipsis allow-user-select" :title="getTeamCapt(event.tbcapt)" v-html="getTeamCapt(event.tbcapt)"></div>
                                        </template>
                                    </div>
                                </div> -->
                                <div class="ellipsis-wrap">
                                  <div class="vrow no-wrap absolute-full">
                                    <div class="team-name away ellipsis allow-user-select" :title="getTeamCapt(event.tbcapt)" v-html="getTeamCapt(event.tbcapt)"></div>
                                    <span class="red-ball" :style="{ display : (event.rbinfo && event.rbinfo.rcb>0) ? 'block':'none' }">
                                      <template v-if="(event.rbinfo && event.rbinfo.rcb>0)">
                                        {{ event.rbinfo.rcb }}
                                      </template>
                                    </span>
                                  </div>
                                </div>
                                <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamAway" :plyType="ftPlyType" :betType="(isRB? ronex2BetType:onex2BetType)" :mode="'simple'" />
                                <!-- <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamAway" :plyType="ftPlyType" :betType="(isRB? ronex2BetType:onex2BetType)" /> -->
                            </div>
                        </div>
                        <div class="yb-flex-center" style="width: 30%;">
                            <div class="play-count-wrap vrow no-wrap">
                                <span class="play-count" style="margin-right: 5px;" @click="enterAllBet(event,3,isRB)">+{{ countAllBet(event) }}</span>
                                <span class="yb-flex-center">
                                    <div class="yb-icon-arrow"></div>
                                </span>
                            </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <moreBetComponent v-if="chkMoreBetExist(event, true)" :event="event" :widthColumn="widthColumn" :isUnfold="isUnfold"></moreBetComponent>
          </div>
          <div class="media-col media-col-simple">
            <div class="media-col-wrap">
              <div class="icon-wrap">
                <span class="yb-flex-center yb-hover-bg m-star-wrap-match" @click="favourite(event, true)">
                  <i aria-hidden="true" class="icon-star q-icon c-icon" :class="{'active': event.isFavourite}"></i>
                </span>
              </div>
              <div class="icon-wrap after_tpl0 relative-position" :class="{ active: (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }">
                <div class="v-icon switch-icon" @click="enterAllBet(event,1,isRB)" :class="{ active:  (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }" :title="sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']"></div>
              </div>
              <div class="yb-flex-center"></div>
              <div data-v-5a29cfce="" class="icon-wrap relative-position" v-if="event.rbstatus && event.rbinfo && tvIconFlag && event.ch>0" :class="{ active: livetvEveid== event.eveid}"> 
                <div data-v-5a29cfce="" class="v-icon video-icon"  @click="enterAllBet(event,2,isRB)" :class="{ active: livetvEveid== event.eveid}" :title="sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import EventBus from '../../events/event-bus'
  import allBetMixin from '@/vue/mixins/allBet'
  import sportFavourite from '@/vue/mixins/favourite'
  import sportTime from './sportTimeColumn'
  import moreBetComponent from './allBet/more-bet'
  
  export default {
    props: {
        event: null,
        // plytyp: null,
        // bettyp: null,
        // submatchkey: null,
        isRB: null,
        widthColumn: null,
        isUnfold: null,
        firstEventEveid: null,
        livetvEveid: null,
    },
    mixins: [allBetMixin,sportFavourite],
    components: {
      sportTime,
      moreBetComponent,
    },
    computed: {
      ...mapGetters([
        'sportTableLang',
        'sportAllBetLang',
        'selectedShow',
        'selectedMarket',
        'account',
        'simpleSport',
        'tvIconFlag',
      ]),
    },
    data() {
      return {
        selectedLang: window._langid,
        lang: window.lang,
        subMatchKeyCap: {
          0: 'a',
          1: 'b',
          2: 'c',
          3: 'd'
        }
      }
    },
    methods: {
      countAllBet(event, selectedShow=null) {
        var countCv = event.all
        // if (event.od) {
        //   $.each(event.od, function (plyTypes, drawBt) {
        //     if (selectedShow == 3 && plyTypes == 2) {
        //     } else if (selectedShow == 4 && plyTypes == 1) {
        //     } else {
        //       $.each(drawBt, function (bidx, drawDual) {
        //         if (bidx == 1 || bidx == 2 || bidx == 8 || bidx == 9) {
        //           $.each(drawDual, function (dd, val) {
        //             --countCv;
        //           });
        //         } else if (bidx == 4 || bidx == 11) {
        //           if (selectedShow == 2) {
        //             --countCv;
        //           }
        //         }
        //       });
        //     }
        //   });
        // }
        return countCv;
      },
      enterAllBet(event,startTv, isRB) {
        if(this.$store.getters.account.previewFlag && !this.$store.getters.isLiveOn){
          if (window._hasRedirect && startTv == 2) {
            $('.login-redirect-dialog').show();
            return false;
          }
          startTv=1;
        }
        this.$store.dispatch('getMatchAllBet', {
          event: event,
          isRB: isRB,
          // isRB: (event.rbstatus==1) ? true : false,
          token: token.arr_8,
          loadTemplate: startTv  // 1 open right score board only, 2 open live tv, 3 open right score board + all bet, 0 all bet only
        })
        if(startTv == 1 || startTv == 3){
          this.$store.commit('RIGHT_BOARD_CHG', event)
        }
      },
      teamColor(event, team, plytyp) {
        var cls = '';
        if (plytyp == "") {
          plytyp = 1;
        }
        if (event.od[plytyp] && event.od[plytyp][1] && !_.isUndefined(event.od[plytyp][1]['a']) && event.od[plytyp][1]['a']['hdp'] == '0') {
        } else if (event.od[plytyp] && event.od[plytyp][8] && !_.isUndefined(event.od[plytyp][8]['a']) && event.od[plytyp][8]['a']['hdp'] == '0') {
        } else {
          if (team == 'A' && event.od[plytyp] && event.od[plytyp][1] && !_.isUndefined(event.od[plytyp][1]['a']) && event.od[plytyp][1]['a']['fav'] == 'a') {
            cls = 'bold' //red
          } else if (team == 'A' && event.od[plytyp] && event.od[plytyp][8] && !_.isUndefined(event.od[plytyp][8]['a']) && event.od[plytyp][8]['a']['fav'] == 'a') {
            cls = 'bold' //red
          } else if (team == 'B' && event.od[plytyp] && event.od[plytyp][1] && !_.isUndefined(event.od[plytyp][1]['a']) && event.od[plytyp][1]['a']['fav'] == 'b') {
            cls = 'bold' //red
          } else if (team == 'B' && event.od[plytyp] && event.od[plytyp][8] && !_.isUndefined(event.od[plytyp][8]['a']) && event.od[plytyp][8]['a']['fav'] == 'b') {
            cls = 'bold' //red
          }
        }
        return cls
      },
      getTeamCapt(teamCapt, selectedMarket=null) {
        var t = teamCapt
        if (selectedMarket == 'cs') {
          t = t + ' - ' + this.sportAllBetLang['ALL_BET.SUBHEADER_CS']
        }
  
        return t
      },
      getWidth() {
        var widthValue = 150
        if(this.$store.getters.miniNormal) {
          widthValue += 50
        }
        if(this.$store.getters.show_Fold) {
          widthValue += 130
        }
        return 'width: '+widthValue+'px'
      },
    },
    beforeMount() {
    },
    mounted() {
    },
    updated() { 
    },
    beforeDestroy() {
    },
    destroyed() {
    },
  }
</script>
<style lang="scss"></style>
  


// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/simpleSoccer.vue